var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Clear, SearchOutlined } from '@mui/icons-material';
import { debounce } from 'lodash';
var SearchInput = function (_a) {
    var onSearch = _a.onSearch, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.initialQuery, initialQuery = _c === void 0 ? '' : _c, _d = _a.placeholder, placeholder = _d === void 0 ? '' : _d, rightHandSideSearch = _a.rightHandSideSearch, forceExpand = _a.forceExpand, _e = _a.textFieldSize, textFieldSize = _e === void 0 ? 300 : _e, _f = _a.debounceTime, debounceTime = _f === void 0 ? 1000 : _f, searchSidebarTrigger = _a.searchSidebarTrigger;
    // Make sure it's always closed initially
    var _g = useState(false), isExpanded = _g[0], setIsExpanded = _g[1];
    var _h = useState(initialQuery), searchQuery = _h[0], setSearchQuery = _h[1];
    var inputRef = useRef(null);
    var onSearchRef = useRef(onSearch);
    onSearchRef.current = onSearch;
    var debouncedOnSearch = useMemo(function () { return debounce(function (query) { return onSearchRef.current(query); }, debounceTime); }, [debounceTime]);
    useEffect(function () {
        if (isExpanded && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isExpanded]);
    useEffect(function () {
        // If the sidebar is closed, we want to reset the search query and collapse the search input
        if (searchSidebarTrigger === false) {
            handleClear();
        }
    }, [searchSidebarTrigger]);
    useEffect(function () {
        return function () {
            debouncedOnSearch.cancel();
        };
    }, [debouncedOnSearch]);
    var handleExpandClick = function () {
        setIsExpanded(true);
    };
    var handleBlur = function () {
        if (searchQuery === '') {
            setIsExpanded(false);
        }
    };
    var handleChange = function (e) {
        var newQuery = e.target.value;
        setSearchQuery(newQuery);
        debouncedOnSearch(newQuery);
    };
    var handleClear = function () {
        debouncedOnSearch.cancel();
        setIsExpanded(false);
        setSearchQuery('');
        onSearch('');
        if (inputRef.current) {
            inputRef.current.focus();
        }
    };
    var renderSearchTextField = function () { return (_jsx(TextField, { autoFocus: forceExpand, inputRef: inputRef, hiddenLabel: true, placeholder: placeholder, size: "small", value: searchQuery, onChange: handleChange, onBlur: handleBlur, InputProps: {
            startAdornment: (_jsx(InputAdornment, __assign({ position: "start" }, { children: _jsx(SearchOutlined, {}) }))),
            endAdornment: searchQuery ? (_jsx(InputAdornment, __assign({ position: "end" }, { children: _jsx(IconButton, __assign({ "aria-label": "clear search", onClick: handleClear, edge: "end", size: "small" }, { children: _jsx(Clear, { fontSize: "small" }) })) }))) : undefined,
        }, sx: { width: { xs: 250, sm: textFieldSize } } })); };
    if (!isExpanded && !forceExpand) {
        // If RHS search -> just return back as we don't show the search icon
        // Seach icon is already inside the sidebar
        if (rightHandSideSearch) {
            return null;
        }
        return (_jsx(IconButton, __assign({ onClick: handleExpandClick }, { children: _jsx(SearchOutlined, { color: "secondary" }) })));
    }
    return (renderSearchTextField());
};
export default SearchInput;
